import { ID } from "@bdfx/mergado-ui-kit/lib/helpers/types"
import { ApiRequest } from "app/types/api-types"
import { Action } from "app/types/app-types"
import { ViewTableType } from "products/containers"
import { FiltersFormType } from "products/types/filtertypes"

//TYPES:
export const CREATE_TEMPLATE_EXPORT: ApiRequest = {
    CREATE: "CREATE_TEMPLATE_EXPORT_CREATE",
    STARTED: "CREATE_TEMPLATE_EXPORT_STARTED",
    SUCCESS: "CREATE_TEMPLATE_EXPORT_SUCCESS",
    ERROR: "CREATE_TEMPLATE_EXPORT_ERROR",
}
export const GET_TEMPLATE_EXPORT: ApiRequest = {
    CREATE: "GET_TEMPLATE_EXPORT_CREATE",
    STARTED: "GET_TEMPLATE_EXPORT_STARTED",
    SUCCESS: "GET_TEMPLATE_EXPORT_SUCCESS",
    ERROR: "GET_TEMPLATE_EXPORT_ERROR",
}
export const DOWNLOAD_TEMPLATE_EXPORT = 'DOWNLOAD_TEMPLATE_EXPORT'
export const GET_TEMPLATE_EXPORT_RESET = 'GET_TEMPLATE_EXPORT_RESET'

export const CREATE_PRODUCTS_EXPORT: ApiRequest = {
    CREATE: "CREATE_PRODUCTS_EXPORT_CREATE",
    STARTED: "CREATE_PRODUCTS_EXPORT_STARTED",
    SUCCESS: "CREATE_PRODUCTS_EXPORT_SUCCESS",
    ERROR: "CREATE_PRODUCTS_EXPORT_ERROR",
}
export const GET_PRODUCTS_EXPORT: ApiRequest = {
    CREATE: "GET_PRODUCTS_EXPORT_CREATE",
    STARTED: "GET_PRODUCTS_EXPORT_STARTED",
    SUCCESS: "GET_PRODUCTS_EXPORT_SUCCESS",
    ERROR: "GET_PRODUCTS_EXPORT_ERROR",
}
export const GET_PRODUCTS_EXPORT_RESET = 'GET_PRODUCTS_EXPORT_RESET'
export const DOWNLOAD_PRODUCTS_EXPORT = 'DOWNLOAD_PRODUCTS_EXPORT'

export const CREATE_SIMILARITY_EXPORT: ApiRequest = {
    CREATE: "CREATE_SIMILARITY_EXPORT_CREATE",
    STARTED: "CREATE_SIMILARITY_EXPORT_STARTED",
    SUCCESS: "CREATE_SIMILARITY_EXPORT_SUCCESS",
    ERROR: "CREATE_SIMILARITY_EXPORT_ERROR",
}
export const GET_SIMILARITY_EXPORT: ApiRequest = {
    CREATE: "GET_SIMILARITY_EXPORT_CREATE",
    STARTED: "GET_SIMILARITY_EXPORT_STARTED",
    SUCCESS: "GET_SIMILARITY_EXPORT_SUCCESS",
    ERROR: "GET_SIMILARITY_EXPORT_ERROR",
}
export const GET_SIMILARITY_EXPORT_RESET = 'GET_SIMILARITY_EXPORT_RESET'
export const DOWNLOAD_SIMILARITY_EXPORT = 'DOWNLOAD_SIMILARITY_EXPORT'

export const initialExportState = {
    checking: [],
    done: [],
    isExporting: false,
    isExported: false,
    isError: false,
    data: null,
}

export type ExportDoneType = {
    id: ID
    blob?: string
    rows_total?: number
    duration?: number
    file_name?: string
}

export type ExportDataType = {
    id: ID
    status?: string
    file_url?: string
    file_name?: string
    template_id?: ID
    template_ids?: ID[]
    list_checksum?: string
    total_rows?: number
    exported_rows?: number
    rows_total?: number
    rows_completed?: number
    error?: string
    query?: string
    progress?: number
    created_at?: string
    updated_at?: string
    started_at?: string
    finished_at?: string
}

export type VisualSimilarityExportType = {
    id: ID
    template_id: ID
    list_checksum: string
    total_rows: number
    exported_rows: number
    error: string
    created_at: string
    updated_at: string
    started_at: string
    finished_at: string
}

export type ExportsType = {
    checking: ID[]
    done: ExportDoneType[]
    isExporting: boolean
    isExported: boolean
    isError: boolean
    data: ExportDataType
}


//REDUCERS:
export const exportSimilarityReducer = (state: ExportsType = initialExportState, action: Action<VisualSimilarityExportType>): ExportsType => {
    switch (action.type) {
        case CREATE_SIMILARITY_EXPORT.CREATE:
            return {
                ...state,
                isExporting: true,
                isExported: false
            }
        case CREATE_SIMILARITY_EXPORT.SUCCESS:
            return {
                ...state,
                checking: [...state.checking, action.payload.id],
                data: action.payload,
                isExporting: true,
                isExported: false,
            }
        case CREATE_SIMILARITY_EXPORT.ERROR:
            console.error('error while create export', action)
            return {
                ...state,
                isExporting: false,
                isExported: false,
            }
        case GET_SIMILARITY_EXPORT.SUCCESS:
            const isFinished = state.data.id === action.payload.id && !!action.payload.finished_at
            const isError = isFinished && !action.payload.list_checksum
            return {
                ...state,
                data: state.data.id === action.payload.id ? action.payload : state.data,
                isExporting: !isFinished,
                isExported: isFinished,
                isError: isError,
                checking: isFinished ? [...state.checking.filter(o => o !== action.payload.id)] : state.checking,
                done: isFinished ? [...state.done, action.payload] : state.done
            }
        case DOWNLOAD_SIMILARITY_EXPORT:
            return {
                ...state,
                done: [...state.done.filter(o => o.id !== action.payload.id)]
            }
        case GET_SIMILARITY_EXPORT_RESET:
            return initialExportState
        default:
            return state
    }
}

export const exportProductsReducer = (state: ExportsType = initialExportState, action: Action<ExportDataType>): ExportsType => {
    switch (action.type) {
        case CREATE_PRODUCTS_EXPORT.CREATE:
            return {
                ...state,
                isExporting: true,
                isExported: false
            }
        case CREATE_PRODUCTS_EXPORT.SUCCESS:
            return {
                ...state,
                checking: [...state.checking, action.payload.id],
                data: action.payload,
                isExporting: true,
                isExported: false,
            }
        case CREATE_PRODUCTS_EXPORT.ERROR:
            return {
                ...state,
                isExporting: false,
                isExported: false,
            }
        case GET_PRODUCTS_EXPORT.SUCCESS:
            const isFinished = state.data.id === action.payload.id && action.payload.status === "done"
            const isError = isFinished && !action.payload.file_url
            return {
                ...state,
                data: state.data.id === action.payload.id ? { ...action.payload, query: undefined } : state.data,
                isExporting: !isFinished,
                isExported: isFinished,
                isError: isError,
                checking: isFinished ? [...state.checking.filter(o => o !== action.payload.id)] : state.checking,
                done: isFinished ? [...state.done, action.payload] : state.done
            }
        case DOWNLOAD_PRODUCTS_EXPORT:
            return {
                ...state,
                done: [...state.done.filter(o => o.id !== action.payload.id)]
            }
        case GET_PRODUCTS_EXPORT_RESET:
            return initialExportState
        default:
            return state
    }
}

export const exportTemplatesReducer = (state: ExportsType = initialExportState, action: Action<ExportDataType>): ExportsType => {
    switch (action.type) {
        case CREATE_TEMPLATE_EXPORT.CREATE:
            return {
                ...state,
                isExporting: true,
                isExported: false
            }
        case CREATE_TEMPLATE_EXPORT.SUCCESS:
            return {
                ...state,
                checking: [...state.checking, action.payload.id],
                data: action.payload,
                isExporting: true,
                isExported: false,
            }
        case CREATE_TEMPLATE_EXPORT.ERROR:
            return {
                ...state,
                isExporting: false,
                isExported: false,
            }
        case GET_TEMPLATE_EXPORT.SUCCESS:
            const isFinished = state.data.id === action.payload.id && action.payload.status === "done"
            const isError = isFinished && !action.payload.file_url
            return {
                ...state,
                data: state.data.id === action.payload.id ? action.payload : state.data,
                isExporting: !isFinished,
                isExported: isFinished,
                isError: isError,
                checking: action.payload.status === "done" ? [...state.checking.filter(o => o !== action.payload.id)] : state.checking,
                done: action.payload.status === "done" ? [...state.done, action.payload] : state.done
            }
        case DOWNLOAD_TEMPLATE_EXPORT:
            return {
                ...state,
                done: [...state.done.filter(o => o.id !== action.payload.id)]
            }
        case GET_TEMPLATE_EXPORT_RESET:
            return initialExportState
        default:
            return state
    }
}

export const hideTemplateExport = () => ({
    type: GET_TEMPLATE_EXPORT_RESET,
})

//ACTIONS:
export const getProductsExport = (id: ID) => ({
    type: GET_PRODUCTS_EXPORT.CREATE,
    payload: { id },
})

export const getTemplateExport = (id: ID) => ({
    type: GET_TEMPLATE_EXPORT.CREATE,
    payload: { id },
})

export const getSimilarityExport = (id: ID) => ({
    type: GET_SIMILARITY_EXPORT.CREATE,
    payload: { id },
})

export const hideProductsExport = () => ({
    type: GET_PRODUCTS_EXPORT_RESET,
})

export const downloadProductsExport = (id: ID) => ({
    type: DOWNLOAD_PRODUCTS_EXPORT,
    payload: { id }
})

export const downloadTemplateExport = (id: ID) => ({
    type: DOWNLOAD_TEMPLATE_EXPORT,
    payload: { id }
})

export const createProductsExport = (filters: FiltersFormType, viewtable: ViewTableType | 'row') => ({
    type: CREATE_PRODUCTS_EXPORT.CREATE,
    payload: { filters, viewtable },
})

export const createTemplateExport = (templateIds: ID[], isAlt: boolean) => ({
    type: CREATE_TEMPLATE_EXPORT.CREATE,
    payload: { templateIds, isAlt },
})

export const createSimilarityExport = (templateId: ID, templateIds: ID[], productId: ID, nLimit: number, threshold: number, forcePriority: boolean = null) => ({
    type: CREATE_SIMILARITY_EXPORT.CREATE,
    payload: { templateId, templateIds, productId, nLimit, threshold, forcePriority },
})
